import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { SuporteAiLoaderService } from "@core/loaders/suporte-ai-loader.service";
import { SuporteAiService } from "@core/services/suporte-ai.service";
import { SuporteAiDados } from "@app/Domain/Models/suporte-ai-dados.model";

@Component({
    selector: "app-shell",
    standalone: true,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], // Req 3.1
    templateUrl: "./shell.component.html",
    styleUrl: "./shell.component.scss"
})
export class ShellComponent implements OnInit {
    private suporteAi = inject(SuporteAiService);
    private loader = inject(SuporteAiLoaderService);
    private authService = inject(MsalService);

    contextData: SuporteAiDados | null = null;

    /**
     * Reflects the MSAL authentication state (active account), matching how AppComponent decides the
     * authenticated flow (`authService.instance.getActiveAccount() != null`). Rule: no auth, no widget.
     */
    get isAuthenticated(): boolean {
        return this.authService.instance.getActiveAccount() != null;
    }

    ngOnInit(): void {
        if (!this.isAuthenticated) return; // Req 1.3 / 2.3: nothing happens without authentication
        this.suporteAi.getContexto().subscribe({
            next: (data) => {
                if (!this.hasRequiredFields(data)) return; // Req 3.4
                this.contextData = data;
                this.loader.load(data.url); // Req 1.4 — URL do bundle vinda do backend
            },
            error: () => {
                this.contextData = null;
            }
        });
    }

    /** Guard for non-empty required attributes (token,url,user,email,system,entity,area,language). Req 3.4, 12.6 */
    hasRequiredFields(data: SuporteAiDados | null): boolean {
        if (!data) return false;
        const required = [data.token, data.url, data.user, data.email, data.system, data.entity, data.area, data.language];
        return required.every((v) => typeof v === "string" && v.trim().length > 0);
    }

    /** Used in the template *ngIf. */
    get canRender(): boolean {
        return this.hasRequiredFields(this.contextData);
    }
}